import { ReactElement, useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import { useHirePlanForm } from '../../../../contexts/HirePlanFormProviderGdf';
import { useError } from '../../../../stores/useError';
import { useLinkStore } from '../../../../stores/useLinkStore';
import { useLoadingStore } from '../../../../stores/useLoadingStore';
import { useWindowSizeStore } from '../../../../stores/useWindowSizeStore';
import { CartIcon } from '../../../icons/CartIcon';
import PlanLoading from '../../../icons/PlanLoading';
import { ErrorModal } from '../../../Modal/Modal';
import { GoForwardButton } from '../../GoForwardButton';

export function AceiteForm(): ReactElement {
  const { handleSubmit, onSubmit } = useHirePlanForm();

  const width = useWindowSizeStore(state => state.width);

  const loading = useLoadingStore(state => state.loading);
  const error = useError(state => state.error);
  const title = useError(state => state.title);
  const text = useError(state => state.text);
  const link = useLinkStore(state => state.data);

  const handleEncerrar = () => {
    window.location.reload();
  };
  const handleCopiarLink = () => {
    window.navigator.clipboard.writeText(link || '');
    toast.success('Link copiado para a área de transferência!');
  };

  return (
    <form
      action=""
      className="max-w-[766px] w-full"
      onSubmit={handleSubmit(onSubmit)}
    >
      {error && <ErrorModal open={true} title={title} text={text} />}
      <>
        <h2 className="text-[2rem] font-semibold text-center text-primary-main mb-10">
          Aguardando a confirmação
        </h2>
        <PlanLoading />
        <div className="flex justify-center mt-4 gap-4">
          <button
            type="button"
            onClick={handleCopiarLink}
            className="bg-primary-main text-white px-4 py-2 rounded-md hover:bg-primary-dark transition-colors w-full sm:w-auto"
          >
            Copiar Link
          </button>
          <button
            type="button"
            onClick={handleEncerrar}
            className="bg-secondary-main text-white px-4 py-2 rounded-md hover:bg-secondary-dark transition-colors w-full sm:w-auto"
          >
            Encerrar
          </button>
        </div>
      </>
    </form>
  );
}
